import { useEffect, type RefObject } from "react";
import { useTiptapSearchable, useSearchableRegistry, type EditorWrapper } from "../../lib/searchable";

interface TiptapSearchableRegistrarProps {
  editor: EditorWrapper | null | undefined;
  scrollHostRef: RefObject<HTMLElement | null>;
  editorHostNode: HTMLElement | null;
  onOpenFindReplace?: () => void;
}

/**
 * A functional component that registers a TipTap editor with the searchable context.
 * This is used inside class components to bridge to the hook-based searchable system.
 */
export function TiptapSearchableRegistrar({
  editor,
  scrollHostRef,
  editorHostNode,
  onOpenFindReplace,
}: TiptapSearchableRegistrarProps): null {
  const { onOpenFindReplace: registerOpenFindReplace } = useSearchableRegistry();

  useTiptapSearchable(editor, {
    id: "document",
    name: "Document",
    scrollHostRef,
    editorHostNode,
  });

  // Register callback so searchable fields can request to open find/replace
  useEffect(() => {
    if (onOpenFindReplace) {
      return registerOpenFindReplace(onOpenFindReplace);
    }
  }, [onOpenFindReplace, registerOpenFindReplace]);

  // This component doesn't render anything
  return null;
}

export default TiptapSearchableRegistrar;
